'use client';

import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/navigation';

interface BackButtonProps {
	backLinkUrl: string;
	backTitle: string;
	className?: string;
	shouldUseRouterBack?: boolean;
}

export const BackButton = ({ backLinkUrl, backTitle, shouldUseRouterBack, className = '' }: BackButtonProps) => {
	const router = useRouter();

	const handleBack = () => {
		if (shouldUseRouterBack) {
			router.back();
		} else {
			router.push(backLinkUrl);
		}
	};
	return (
		<div onClick={handleBack} className={`flex items-center gap-2 text-gray-900 hover:text-gray-700 cursor-pointer mb-7 mt-6 ${className}`}>
			<FontAwesomeIcon icon={faAngleLeft} className="size-5" />
			<span className="text-base font-medium leading-6 hover:underline underline-offset-4">{backTitle}</span>
		</div>
	);
};
